import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Select, Input } from "antd";
import { connect } from "react-redux";
import { requestServerPost, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import DataHelper from "../../helpers/DataHelper";
import { Copy } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

class DuplicatePlaylistPage extends Component {
  constructor(props) {
    super(props);
    this.state = { fileList: [], branches: [], lastSelectedBranches: [] };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { selectedBrandData, selectedBranchData, data } = this.props;
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    if ((sharingMode == 2 || sharingMode == "2") && !selectedBranchData) {
      DataHelper.getBranches(
        { brandid: selectedBrandData.BrandID },
        this.props,
      ).then((data) => {
        this.setState({ branches: data || [] });
      });
    }

    let initialAccessBranches = ["all"];
    if (data && data.AccessBranches) {
      const acc = data.AccessBranches;
      if (acc !== "all" && acc !== "null" && acc !== "") {
        initialAccessBranches = String(acc)
          .split(",")
          .map((s) => s.trim());
      }
    }
    this.setState({ lastSelectedBranches: initialAccessBranches });
  }

  handleBranchChange = (value) => {
    let newValues = [...value];
    if (
      newValues.includes("all") &&
      !this.state.lastSelectedBranches?.includes("all")
    ) {
      newValues = ["all"];
    } else if (newValues.includes("all") && newValues.length > 1) {
      newValues = newValues.filter((v) => v !== "all");
    } else if (newValues.length === 0) {
      newValues = ["all"];
    }

    this.setState({ lastSelectedBranches: newValues });
    this.formRef.current.setFieldsValue({ accessbranches: newValues });
  };

  normFile = (e) => {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  onChange = ({ fileList: newFileList }) => {
    // console.log("onChange " + JSON.stringify(newFileList))
    this.setState({ fileList: newFileList });
  };

  onPreviewDrop = (files) => {
    this.setState({
      files: this.state.fileList.concat(files),
    });
  };

  onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      selectedBranchData,
      data = null,
      onPlaylistCreated = () => {},
    } = this.props;
    var params = new FormData();

    // Determine create level and accessbranches based on ContentSharingMode
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    let createlevel = 1;
    let accessbranches = "all";

    if (sharingMode == 2) {
      const isBrandLevel = !selectedBranchData;
      createlevel = isBrandLevel ? 1 : 2;
      if (isBrandLevel) {
        if (values.accessbranches && values.accessbranches.includes("all")) {
          accessbranches = "all";
        } else if (values.accessbranches && values.accessbranches.length > 0) {
          accessbranches = values.accessbranches.join(",");
        } else {
          accessbranches = "all";
        }
      } else {
        accessbranches = selectedBranchData.BranchID;
      }
    }

    if (data) {
      params.append("playlistid", data.PlaylistID);
      params.append("playlistname", values.playlistname);
      params.append("createlevel", createlevel);
      params.append("accessbranches", accessbranches);
      requestServerPost(
        "duplicate_playlist",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    } else {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("playlistname", values.playlistname);
      params.append("createlevel", createlevel);
      if (accessbranches !== null) {
        params.append("accessbranches", accessbranches);
      }
      requestServerPost(
        "create_playlist",
        params,
        {},
        (response) => {
          onPlaylistCreated(response.data.playlistid);
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  render() {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      selectedBranchData,
      data = null,
      langT,
    } = this.props;
    const t = langT || {
      title: "Duplicate Playlist",
      subtitle: "Give the copy a new name",
      newNameLabel: "New Playlist Name",
      newNamePlaceholder: "e.g. Morning Loop (copy)",
      newNameRequired: "Please enter a playlist name",
      branchAccessLabel: "Branch Access",
      branchAccessPlaceholder: "Select branches",
      branchAccessRequired: "Please select branch access",
      allBranches: "All Branches",
      duplicateBtn: "Duplicate Playlist",
    };
    const sharingMode = selectedBrandData
      ? selectedBrandData.ContentSharingMode
      : null;
    const isBrandLevel = !selectedBranchData;
    const showBranchSelector =
      (sharingMode == 2 || sharingMode == "2") && isBrandLevel;

    let initialAccessBranches = ["all"];
    if (data && data.AccessBranches) {
      const acc = data.AccessBranches;
      if (acc !== "all" && acc !== "null" && acc !== "") {
        initialAccessBranches = String(acc)
          .split(",")
          .map((s) => s.trim());
      }
    }

    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };
    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <Copy size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {t.title}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {t.subtitle}
          </div>
        </div>
        <div style={{ ...body }}>
          <Form
            name="duplicate_playlist_form"
            {...formItemLayout}
            ref={this.formRef}
            onFinish={this.onFinish}
            initialValues={{
              playlistname: data ? data.PlaylistName : "",
              accessbranches: initialAccessBranches,
            }}
          >
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.newNameLabel}
              </label>
              <Form.Item
                name="playlistname"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.newNameRequired }]}
              >
                <Input
                  size="large"
                  placeholder={t.newNamePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>
            {showBranchSelector && (
              <div style={{ marginBottom: 20 }}>
                <label
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    display: "block",
                    marginBottom: 6,
                  }}
                >
                  {t.branchAccessLabel}
                </label>
                <Form.Item
                  name="accessbranches"
                  style={{ marginBottom: 0 }}
                  rules={[{ required: true, message: t.branchAccessRequired }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder={t.branchAccessPlaceholder}
                    onChange={this.handleBranchChange}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    <Option key="all" value="all">
                      {t.allBranches}
                    </Option>
                    {this.state.branches.map((b) => (
                      <Option key={b.BranchID} value={String(b.BranchID)}>
                        {b.BranchName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}
            <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                }}
              >
                {t.duplicateBtn}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedDuplicatePlaylistPage = connect(mapStateToProps, {
  requestServerPost,
  requestServerPost,
  selectPage,
})(DuplicatePlaylistPage);

const DuplicatePlaylistPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const langT = PRO_TRANSLATIONS[lang].duplicatePlaylist;
  return <ConnectedDuplicatePlaylistPage {...props} langT={langT} />;
};

export default DuplicatePlaylistPageWithLang;
